module.exports = __webpack_public_path__ + "img/logoFPheader.f9e68ec1.svg";